module.exports = __webpack_public_path__ + "efb4d20132982438279fcd0d9a8b49f8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-6.png
// module id = 2545
// module chunks = 0